import sidebar from './sidebar';

export default {
  namespaced: true,
  modules: {
    sidebar,
  },
};
